import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  loading: false,
  error: false,
  success: false,
  message: null,
  token: null,
  hasBank: false,
  hasCard: false,
  hasCover: false,
};

export const loginAction = createAsyncThunk(
  "loginAction",
  ({ user, hasBank, hasCard, hasCover, token }) => {
    return {
      user,
      hasBank,
      hasCard,
      hasCover,
      token,
    };
  }
);

//CREATE THE SLICE

export const authLoginSlice = createSlice({
  name: "authLogin",
  initialState,
  reducers: {
    //non asynchronous reducers goes here
    reset: (state) => {
      state.loading = false;
      state.error = false;
      state.success = false;
      state.message = "";
      state.user = {};
      state.token = null;
      state.hasBank = false;
      state.hasCard = false;
      state.hasCover = false;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(loginAction.pending, (state) => {
        state.loading = true;
      })
      .addCase(loginAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.user = action.payload?.user;
        state.token = action.payload?.token;
        state.hasBank = action.payload?.hasBank;
        state.hasCard = action.payload?.hasCard;
        state.hasCover = action.payload?.hasCover;
      })
      .addCase(loginAction.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.message = action.payload;
        state.user = null;
      });
  },
});

export const { reset } = authLoginSlice.actions;

export default authLoginSlice.reducer;
